module.exports = __webpack_public_path__ + "static/SorabhGupta-47db21a2f2fe707302da56a6d5abf8d4.jpg";